// Librerias
import React from 'react'
let PropTypes = React.PropTypes
import * as css from './TablaInventarios.css'

export class RowInventario extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    render(){
        if (this.props.inventario){
            return (
                <tr key={1}>
                    <td>{this.props.correlativo}</td>
                    <td>{this.props.inventario.inv_fechaProgramadaF}</td>
                    <td>{this.props.inventario.cliente_nombre}</td>
                    <td className={css.tdCeco}>{this.props.inventario.local_ceco}</td>
                    <td>{this.props.inventario.local_nombre}</td>
                    <td className={css.tdUnidadSEI}>{this.props.inventario.inv_diferenciaInfReal.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                    <td className={css.tdInf}>{this.props.inventario.inv_unidadesInformadas.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                    <td className={css.tdInf}>{this.props.inventario.inv_unidadesReal.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                    <td className={css.tdUnidadSEI}>{this.props.inventario.precio_unidad}</td>
                    <td className={css.tdUnidadSEI}>{this.props.inventario.total_servicio.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                </tr>
            )     
        }
        else if(this.props.valorNeto){
            return (
                <tr key={2}>
                    <td>{this.props.correlativo}</td>
                    <td>{}</td>
                    <td>{}</td>
                    <td>{}</td>
                    <td>{}</td>
                    <td>{}</td>
                    <td>{}</td>
                    <td>{}</td>
                    <td>{}</td>
                    <td className={css.tdUnidadSEI}>{this.props.valorNeto}</td>
                </tr>
            )
        }
    }
}
RowInventario.propTypes = {
    inventario: PropTypes.object,
    correlativo: PropTypes.string,
    sumaUnidades: PropTypes.string,
    valor: PropTypes.string,
    aprobacionCliente: PropTypes.func,
    aprobacionSei: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/inventarios/inventarios-facturacion/peticionOC/RowInventario.jsx